var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandingDownloadButtonbg = function SvgBrandingDownloadButtonbg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413,
    height: 303,
    viewBox: "0 0 413 303"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 12,
    x: 52,
    y: 190,
    fill: "current",
    fillRule: "evenodd",
    rx: 0.965
  })));
};
export default SvgBrandingDownloadButtonbg;